import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import InputDropdown from "@/Components/Form/InputDropdown";
import { LuChevronDown } from "@/Components/Icons/Icons";
import { useInvoice } from "@/Context/InvoiceContext";
import { useUser } from "@/Context/UserContext";
import { hookMap } from "@/redux/hookMap";
import { useParams } from "react-router";

export default function ProductTabBox({ handleRowSelect }) {
  const { invoiceId, setInvoiceId } = useInvoice();
  const { formData, setFormData } = useUser();
  const invoice = formData["invoiceMain"] || [];

  const options = invoice.map((invoice) => ({
    value: invoice.exportInvoiceId,
    label: invoice.exportInvoiceNumber,
  }));

  const selectedInvoice = invoice.find(
    (inv) => inv.exportInvoiceId === invoiceId
  );

  // ✅ Get values safely
  // ✅ Get values safely
  const productValue = selectedInvoice?.exportInvoiceproductvalue ?? "0";
  const termsOfInvoice = selectedInvoice?.exportInvoiceTOI ?? "0";
  const InvoiceUpdateDate = selectedInvoice?.exportInvoiceUpdateDate ?? "N/A";
  const { fetch: fetchInvoice, data, isLoading } = hookMap.invoiceMain();

  const { exporterId } = useParams(); // Get exporterMasterId from UserContext

  useEffect(() => {
    // Fetch invoiceMain only if we have masterId and invoice data is empty
    if (exporterId && !formData.invoiceMain?.length) {
      fetchInvoice({ id: exporterId })
        .then((res) => {
          setFormData((prev) => ({ ...prev, invoiceMain: res || [] }));
        })
        .catch((err) => console.error("Failed to fetch invoiceMain:", err));
    }
  }, [exporterId, invoiceId, options]);

  useEffect(() => {
    if (!invoice || invoice.length === 0) return;

    const selectedInvoice = invoice.find((inv) => inv.selected);
    if (selectedInvoice) {
      setInvoiceId(selectedInvoice.id);
    } else {
      const updatedInvoices = invoice.map((inv, index) => ({
        ...inv,
        selected: index === 0 ? true : false, // ← select 1st only
      }));

      setFormData((prev) => ({
        ...prev,
        invoiceMain: updatedInvoices,
      }));

      setInvoiceId(updatedInvoices[0].id);
    }
  }, [invoice]);

  const handleChange = (e) => {
    setInvoiceId(e);
    useInvoice;
    handleRowSelect(e, "","invoiceMain");
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{ px: 2, paddingTop: 2, paddingBottom: 0.5, gap: 10 }} // reduce vertical and horizontal spacing
    >
      <Box display="flex" alignItems="center" gap={1.5}>
        <Typography variant="bodyMedium" sx={{ minWidth: "100px" }}>
          Invoice Number:
        </Typography>
        <InputDropdown
          gap={false}
          value={invoiceId}
          onChange={handleChange}
          options={options.map(({ label, value }) => ({ label, value }))}
          placeholder="Select Invoice"
          width="200px"
          sx={{ mt: 0.6 }}
          endIconName={LuChevronDown}
        />
        <Typography variant="bodyMedium">{InvoiceUpdateDate}</Typography>
      </Box>

      <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row" }} // ⬅️ Column on small, row on medium
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent={"center"}
        gap={2}
        flexWrap="wrap"
      >
        {/* Product Value */}
        <Box display="flex" alignItems="center" gap={0.5}>
          <Typography variant="bodySmall" color="text.secondary">
            Product Value:
          </Typography>
          <Typography variant="bodySmall" fontWeight={600}>
            {productValue}
          </Typography>
        </Box>

        {/* Terms Of Invoice */}
        <Box display="flex" alignItems="center" gap={0.5}>
          <Typography fontSize="14px" color="text.secondary">
            Terms Of Invoice:
          </Typography>
          <Typography fontSize="14px" fontWeight={600}>
            {termsOfInvoice}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
